import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../layouts/Layout";
import MenuBar from "../../../layouts/MenuBar";
import Chat from "../../../shared/Chat/Chat";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getGroupsWithConversations } from "../../../services/api";
import { useSearchParams } from "react-router-dom";
import { filterOptionsActions } from "../../../store/FiltersOptions";

const RegulatorMessages = () => {
     const sessionData = useSelector((state) => state.auth.sessionData);
    const dispatch = useDispatch();
    const multipartheaders = useMemo(() => {
        return { sessionid: sessionData.sessionId, "Content-Type": "multipart/form-data" };
    }, [sessionData.sessionId]);
    const [conversations, setConversations] = useState([]);
    const [initialMessages, setInitialMessages] = useState([]);
    const [ids, setIds] = useState({});
    const hasInitialized = useRef(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const group = searchParams.get('group');
    const getRegulatorConversationHandler = useCallback((type = '') => {
        const getResponse = (response) => {
            if (response.result === "SUCCESS") {
                const { conversations = [], totalUnreadConversations = 0 } = response.data || {};
                const { groupID, companyName } = sessionData || {};
                const singleGroup = {
                    groupID,
                    groupName: companyName,
                    conversations
                };
                setConversations([singleGroup]);
                const hasConversations = conversations.length > 0;
                const firstConversation = conversations[0];
                dispatch(filterOptionsActions.setMessageCount(totalUnreadConversations ?? 0));

                if (!type && !hasInitialized.current && !group && hasConversations) {
                    setIds({
                        conversationID: firstConversation.conversationID,
                        groupID,
                        groupName: companyName,
                        isRead: firstConversation.unreadMessageCount ? true : false
                    });

                    setInitialMessages(
                        firstConversation.messages?.length
                            ? [...firstConversation.messages].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                            : []
                    );
                }
            } else {
                setConversations([]);
            }
        };
        getGroupsWithConversations(multipartheaders, dispatch, getResponse);
    }, [dispatch, group, multipartheaders, sessionData]);
    useEffect(() => {
        getRegulatorConversationHandler();
    }, [getRegulatorConversationHandler]);
    useEffect(() => {
        const group = searchParams.get('group');
        const conversation = searchParams.get('conversation');

        if (!hasInitialized.current && group && conversation && sessionData.groupID === +group) {
            setIds({ conversationID: +conversation, groupID: +group, groupName: sessionData.companyName})
            const newParams = new URLSearchParams(searchParams.toString());
            newParams.delete('group');
            newParams.delete('conversation');
            setSearchParams(newParams);
            hasInitialized.current = true;
        }
    }, [searchParams, sessionData.companyName, sessionData.groupID, setSearchParams]);
     const refetchHandler = (data) => {
        setIds(data)
        getRegulatorConversationHandler('refetch');
    }
    return (<>
        <Layout>
            <MenuBar></MenuBar>
            <Chat type={'regulator'} conversations={conversations} refetchHandler={refetchHandler}ids={ids} initialMessages={initialMessages}></Chat>
        </Layout>

    </>)

}

export default RegulatorMessages;